import {
    instagram,
    messenger,
    skype,
    telegram,
    viber,
    whatsapp,
    snapchat,
    phone,
} from "../../../assets/icon";

export const icons = [
    { src: telegram, title: "telegram", typeName: "telegram" },
    { src: viber, title: "viber", typeName: "viber" },
    { src: whatsapp, title: "whatsapp", typeName: "whatsapp" },
    { src: messenger, title: "messenger", typeName: "messenger" },
    { src: instagram, title: "instagram", typeName: "instagram" },
    { src: skype, title: "skype", typeName: "skype" },
    { src: snapchat, title: "snapchat", typeName: "snapchat" },
    { src: phone, title: "contacts", typeName: "contacts" },
];